<template>
    <div class="kv-action-switch-wrapper d-flex align-items-center gap-xl">
        <label class="switch" :style="cssVars">
            <input type="checkbox" :id="id" :checked="isChecked" @change="onChange" />
            <span class="slider">
                <Icon :icon-class="falseIcon" class="track-icon icon-left" />
                <Icon :icon-class="trueIcon" class="track-icon icon-right" />
                <span class="thumb"></span>
            </span>
        </label>
    </div>
</template>

<script>
import Icon from '@/components/icon/icon.vue';

export default {
    name: "KvActionSwitch",
    components: { Icon },
    props: {
        id: String,
        value: { default: false },
        trueIcon: { type: String, default: "ui-plus" },
        falseIcon: { type: String, default: "ui-minus" },
        trueColor: { type: String, default: "#17B26A" },
        falseColor: { type: String, default: "#F04438" },
        returnType: {
            type: String,
            default: "boolean",
            validator: (v) => ["boolean", "number"].includes(v)
        }
    },
    computed: {
        isChecked() {
            return this.value === true || this.value == 1;
        },
        cssVars() {
            const activeColor = this.isChecked ? this.trueColor : this.falseColor;
            return {
                "--theme-color": activeColor,
            };
        }
    },
    methods: {
        onChange(e) {
            const boolValue = e.target.checked;
            const output = this.returnType === "number" ? (boolValue ? 1 : 0) : boolValue;
            this.$emit("input", output);
        }
    }
};
</script>

<style lang="scss" scoped>
.kv-action-switch-wrapper {
    .switch {
        font-size: 17px;
        position: relative;
        display: inline-block;
        height: 36px;
        width: 78px;
        margin: 0 !important;

        input {
            opacity: 0;
            width: 0;
            height: 0;
        }

        .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #FFFFFF;
            border: 1px solid #F3F4F6;
            transition: .4s;
            border-radius: 4.8px;
            outline: none;

            .track-icon {
                position: absolute;
                top: 50%;
                transform: translate(-50%, -50%);
                z-index: 2;
                font-size: 14px;
                color: #D2D6DB !important;
                transition: color 0.3s ease;
                pointer-events: none;

                // Centralização do SVG/Fonte
                display: flex;
                align-items: center;
                justify-content: center;
                width: 18px;
                height: 18px;
            }

            // CORREÇÃO: Alinhamento baseado em pixels
            // Thumb margem (4px) + Metade do Thumb (16px) = Centro em 20px
            .icon-left {
                left: 20px; 
            }

            // Centro Esquerdo (20px) + Deslocamento do Thumb (38px) = Centro em 58px
            .icon-right {
                left: 58px;
            }

            .thumb {
                position: absolute;
                border-radius: 3.6px;
                will-change: transform;
                backface-visibility: hidden;
                transition: transform .25s cubic-bezier(0.4, 0.0, 0.2, 1) 0s, background-color .4s;
                
                left: 4px;
                top: 50%;
                height: 28px;
                width: 32px;
                
                // Limpeza: removido o transform duplicado, mantendo apenas o 3d
                transform: translate3d(0, -50%, 0);
                
                background-color: var(--theme-color);
                z-index: 1;
                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
            }
        }

        input:checked+.slider {
            .thumb {
                // Move 38px para a direita
                transform: translate3d(38px, -50%, 0);
                background-color: var(--theme-color);
            }

            .icon-right {
                color: #FCFCFD !important;
            }
        }

        input:not(:checked)+.slider {
            .icon-left {
                color: #FCFCFD !important;
            }
        }
    }
}
</style>